import { render, staticRenderFns } from "./unCompleteBm.vue?vue&type=template&id=48d164c0&scoped=true"
import script from "./unCompleteBm.vue?vue&type=script&lang=ts"
export * from "./unCompleteBm.vue?vue&type=script&lang=ts"
import style0 from "./unCompleteBm.vue?vue&type=style&index=0&id=48d164c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d164c0",
  null
  
)

export default component.exports